import { useCallback } from 'react';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import fetch from 'features/common/fetch';
import { reload } from 'features/views/campaignManagement/contactStates/actions';
import { getAssignedCount, getAvailableCount } from 'features/views/campaignManagement/contactStates/selectors';

export const ContactStatePills = () => {
	const dispatch = useDispatch();

	const assignedCount = useSelector(getAssignedCount);
	const availableCount = useSelector(getAvailableCount);

	const handleReload = useCallback(() => {
		dispatch(reload());
	}, [dispatch]);

	return (
		<ComponentLoader fetchStorePath={fetch.constants.urls.contactStateCount} onReload={handleReload}>
			<Grid container>
				<Grid size={12}>
					<Grid container columnSpacing={6}>
						<Grid>
							<Stack
								direction="row"
								spacing={2}
								sx={{
									alignItems: 'center',
								}}
							>
								<Typography variant="h5" color="text.primary">
									{getLabelMessage('campaignManagement:availableContacts')}
								</Typography>
								<Chip sx={{ minWidth: '60px' }} label={availableCount} color="primary" />
							</Stack>
						</Grid>
						<Grid>
							<Stack
								direction="row"
								spacing={2}
								sx={{
									alignItems: 'center',
								}}
							>
								<Typography variant="h5" color="text.primary">
									{getLabelMessage('campaignManagement:assignedContacts')}
								</Typography>
								<Chip sx={{ minWidth: '60px' }} label={assignedCount} color="primary" />
							</Stack>
						</Grid>
						<Grid size={6} />
					</Grid>
				</Grid>
			</Grid>
		</ComponentLoader>
	);
};

export default ContactStatePills;
